import { Component } from '@angular/core';

@Component({
  selector: 'app-metal-machining',
  templateUrl: './metal-machining.component.html',
  styleUrls: ['./metal-machining.component.scss']
})
export class MetalMachiningComponent {
  advanceMoullding:any[] = [
    {
      title: 'Milling​',
      img: 'assets/images/capability/blue/cnc_machine_1.JPG',
    },
    {
      title: 'Broaching​',
      img: 'assets/images/capability/blue/cnc_machine_2.JPG',
    },
    {
      title: 'Honing, Super Finishing',
      img: 'assets/images/capability/blue/cnc_machine_3.JPG',
    },
    {
      title: 'Turning​',
      img: 'assets/images/capability/blue/cnc_machine_4.JPG',
    },
    {
      title: 'Sliding Head',
      img: 'assets/images/capability/blue/cnc_machine_5.JPG',
    },
    {
      title: 'Centreless Grinding​',
      img: 'assets/images/capability/blue/cnc_machine_6.JPG',
    }
  ]

  produtimglist:any[] = [
    {
      img: 'assets/images/capability/blue/cnc_machine_7.JPG',
    },
    // {
    //   img: 'assets/images/capability/blue/product-image-two.png',
    // },
    // {
    //   img: 'assets/images/capability/blue/product-image-two.png',
    // },
    // {
    //   img: 'assets/images/capability/blue/product-image-two.png',
    // },
    // {
    //   img: 'assets/images/capability/blue/product-image-two.png',
    // },
    // {
    //   img: 'assets/images/capability/blue/product-image-one.png',
    // },    
  ]


  produtimglistone:any[] = [
    {
      img: 'assets/images/capability/blue/cnc_machine_8.JPG',
    },

  ]


  produtimglisttwo:any[] = [
    {
      img: 'assets/images/capability/blue/cnc_machine_9.JPG',
    },

  ]
  
  produtitemlist:any[] = [
    { 'item': 'Gear Rims'},
    { 'item': 'Pistons'},
    { 'item': 'Sleeve and Spool'},
    { 'item': 'Heat Sinks'},
    { 'item': 'Disc valve/Port Plate'},
    { 'item': 'Sub assembly'},
    { 'item': 'Flanges'},
    { 'item': 'Pressure Plates'},
    { 'item': 'Fittings'},
    { 'item': 'Pump body'},
    { 'item': 'Glands'},
    { 'item': 'Check valves'},
  ]

  produtitemlistone:any[] = [
    { 'item': 'Mixing chambers'},
    { 'item': 'Shafts'},
    { 'item': 'Die bodies'},
    { 'item': 'Levers'},
    { 'item': 'Compression pieces'},
    { 'item': 'Fitting'},
    { 'item': 'Flap'},
    { 'item': 'Fuel pumps'},
    { 'item': 'Various couplings'},
    { 'item': 'Quadrants'},
    { 'item': 'Pipes'},
    { 'item': 'Flanges'},
  ]

  produtitemlisttwo:any[] = [
    { 'item': 'Sleeves and Spools'},
    { 'item': 'Pistons'},
    { 'item': 'Fitting'},
    { 'item': 'Casting machining'},
    { 'item': 'Manifold'},
    { 'item': 'Check valves'},
  ]
  
  rawmaterial:any[] = [
    { 'item': 'Copper, Brass, Aluminum, Mild& Stainless Steel, Specialty Steels etc.'},
    { 'item': 'Bars, Forgings, Castings, Die-casting & Profiles.'}
  ]
  diamension:any[] = [
    { 'item': 'Diameter range 6.20-200 mm'},
    { 'item': 'Length–Bar stock of 3000 mm for diameters up to 20 mm'},
    { 'item': 'Max turning length between centre 350 mm'}
  ]

  accuracy:any[] = [
     { 'item':'Concentricity-5 microns'},
     { 'item':'Cylindricity-3 microns'},
     { 'item':'Size-3 microns'},
     { 'item':'Straightness-1 micron'},
     { 'item':'Roundness-1 micron'}
  ]

  surfacetreatment:any[] = [
    { 'item':'All types of Plating - Nitrotec, Zinc, Hard Chrome etc.'},
    { 'item':'Heat treatment, Induction hardening, Case hardening'},
    { 'item':'Aluminium normal Anodizing & Hard Anodizing'},
    { 'item':'Tin Coating, Powder Coating'},
    { 'item':'Electroless Nickel Plating (In-house)'}
 ]

}
